import React from 'react';
import { Divider } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './index.scss';

const CommitteeTransUnionReport = ({ user }) => {
  return (
    <div className="loan-request-info-popup__body__requester-info__popup">
      <div className="loan-request-info-popup__body__requester-info__popup__title">
        TransUnion Report
      </div>
      <Divider />
      <div
        className="loan-request-info-popup__body__requester-info"
        style={{ borderBottom: 'none' }}
      >
        <div className="loan-request-info-popup__body__requester-info__item">
          <div className="loan-request-info-popup__body__requester-info__item__member">
            <span>TransUnion Score</span>
          </div>

          <span>
            {user?.transunion_score?.score_data?.positive_score ||
              'N/A'}
          </span>
        </div>

        <div className="loan-request-info-popup__body__requester-info__item">
          <div className="loan-request-info-popup__body__requester-info__item__member">
            <span>Classification</span>
          </div>

          <span>
            {user?.transunion_score?.score_data?.grade || 'N/A'}
          </span>
        </div>

        <div className="loan-request-info-popup__body__requester-info__item">
          <div className="loan-request-info-popup__body__requester-info__item__member">
            <span>Default Probability</span>
          </div>

          <span>
            {user?.transunion_score?.score_data?.probability || 'N/A'}
          </span>
        </div>
      </div>
    </div>
  );
};

CommitteeTransUnionReport.propTypes = {
  user: PropTypes.object.isRequired,
};

export default CommitteeTransUnionReport;
